import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentValidacaoDadosUsuario from './ContentValidacaoDadosUsuario';

const ArtesFacil = () => {
  return (
    <div className="d-flex flex-column min-h-screen">
      <HeaderApp />
      <ContentValidacaoDadosUsuario />
      <Bottom />
    </div>
  );
};

export default ArtesFacil;
